export default __webpack_public_path__ + "static/media/movie.b2e59a8e.svg";